import React from 'react';

type PropsType = {
  overrideStyle?: React.CSSProperties;
};

const SmallMoneyBagIcon = ({ overrideStyle = {} }: PropsType) => (
  <svg
    style={{ ...overrideStyle }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M45.8032 33.3711L35.7024 14.8719H22.9406L13.1882 32.7403C12.4053 34.1783 11.9956 35.8069 12 37.4634C12.0045 39.1198 12.4229 40.746 13.2134 42.1794C14.004 43.6128 15.139 44.8031 16.5049 45.6314C17.8709 46.4597 19.42 46.8969 20.9973 46.8993H38.3425C39.851 46.9011 41.3334 46.4859 42.6408 45.6954C43.9481 44.905 45.0344 43.7672 45.7904 42.3963C46.5465 41.0254 46.9457 39.4697 46.9479 37.8855C46.9501 36.3013 46.5553 34.7443 45.8032 33.3711V33.3711Z"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.6891 14.8718C40.0051 9.9292 41.66 5.34935 40.2934 3.63348C39.092 2.12264 35.7041 3.0405 34.3886 3.45685C33.7762 2.72616 33.0302 2.13234 32.1948 1.71076C31.3594 1.28917 30.4517 1.04844 29.5259 1.00291C26.4023 0.908281 24.489 3.15405 24.2397 3.45685C22.9182 3.0405 19.5423 2.12264 18.3379 3.63348C16.9683 5.34935 18.6382 9.94182 22.9392 14.8718H35.6891Z"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9567 9.02716L28.1252 14.8718"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6803 7.93567L31.0763 14.8717"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0514 43.942H7.79687C7.30142 43.942 6.89978 44.3638 6.89978 44.8841V47.3385C6.89978 47.8588 7.30142 48.2806 7.79687 48.2806H23.0514C23.5468 48.2806 23.9485 47.8588 23.9485 47.3385V44.8841C23.9485 44.3638 23.5468 43.942 23.0514 43.942Z"
        fill="#FFC72C"
      />
      <path
        d="M23.0514 39.6038H7.79687C7.30142 39.6038 6.89978 40.0256 6.89978 40.5459V43.0003C6.89978 43.5206 7.30142 43.9424 7.79687 43.9424H23.0514C23.5468 43.9424 23.9485 43.5206 23.9485 43.0003V40.5459C23.9485 40.0256 23.5468 39.6038 23.0514 39.6038Z"
        fill="#FFC72C"
      />
      <path
        d="M40.1027 43.942H24.8481C24.3527 43.942 23.951 44.3638 23.951 44.8841V47.3385C23.951 47.8588 24.3527 48.2806 24.8481 48.2806H40.1027C40.5981 48.2806 40.9998 47.8588 40.9998 47.3385V44.8841C40.9998 44.3638 40.5981 43.942 40.1027 43.942Z"
        fill="#FFC72C"
      />
      <path
        d="M40.1027 39.6038H24.8481C24.3527 39.6038 23.951 40.0256 23.951 40.5459V43.0003C23.951 43.5206 24.3527 43.9424 24.8481 43.9424H40.1027C40.5981 43.9424 40.9998 43.5206 40.9998 43.0003V40.5459C40.9998 40.0256 40.5981 39.6038 40.1027 39.6038Z"
        fill="#FFC72C"
      />
      <path
        d="M40.1027 35.2653H24.8481C24.3527 35.2653 23.951 35.687 23.951 36.2074V38.6618C23.951 39.1821 24.3527 39.6039 24.8481 39.6039H40.1027C40.5981 39.6039 40.9998 39.1821 40.9998 38.6618V36.2074C40.9998 35.687 40.5981 35.2653 40.1027 35.2653Z"
        fill="#FFC72C"
      />
      <path
        d="M40.1027 30.9222H24.8481C24.3527 30.9222 23.951 31.344 23.951 31.8643V34.3187C23.951 34.839 24.3527 35.2608 24.8481 35.2608H40.1027C40.5981 35.2608 40.9998 34.839 40.9998 34.3187V31.8643C40.9998 31.344 40.5981 30.9222 40.1027 30.9222Z"
        fill="#FFC72C"
      />
      <path
        d="M40.1027 26.5842H24.8481C24.3527 26.5842 23.951 27.006 23.951 27.5263V29.9807C23.951 30.501 24.3527 30.9228 24.8481 30.9228H40.1027C40.5981 30.9228 40.9998 30.501 40.9998 29.9807V27.5263C40.9998 27.006 40.5981 26.5842 40.1027 26.5842Z"
        fill="#FFC72C"
      />
      <path
        d="M40.1027 22.2452H24.8481C24.3527 22.2452 23.951 22.667 23.951 23.1873V25.6417C23.951 26.162 24.3527 26.5838 24.8481 26.5838H40.1027C40.5981 26.5838 40.9998 26.162 40.9998 25.6417V23.1873C40.9998 22.667 40.5981 22.2452 40.1027 22.2452Z"
        fill="#FFC72C"
      />
      <path
        d="M15.4626 39.6202C20.1738 39.6202 23.9929 35.6094 23.9929 30.662C23.9929 25.7145 20.1738 21.7038 15.4626 21.7038C10.7515 21.7038 6.93237 25.7145 6.93237 30.662C6.93237 35.6094 10.7515 39.6202 15.4626 39.6202Z"
        fill="#FFC72C"
      />
      <path
        d="M15.467 37.6287C19.1307 37.6287 22.1008 34.5096 22.1008 30.6621C22.1008 26.8146 19.1307 23.6956 15.467 23.6956C11.8033 23.6956 8.83325 26.8146 8.83325 30.6621C8.83325 34.5096 11.8033 37.6287 15.467 37.6287Z"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7167 27.1934L12.6096 28.1279L17.2091 34.1376L18.3163 33.2032L13.7167 27.1934Z"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.06189 16.8447V20.5428"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.63635 18.2826L6.47715 21.27"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 22.985H5.99757"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.06189 43.942H22.7892"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1184 26.5842H39.8418"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1184 30.9222H39.8418"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1184 35.2653H39.8418"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1184 39.6038H39.8418"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1184 43.942H39.8418"
        stroke="#0E161C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SmallMoneyBagIcon;
